import { Category } from '@Types/category.types';

// Rows for the classic LoF/CoF tables on Risk Setup: every selected,
// non-zero-weight component of every non-zero-weight category.
export const buildComponentTableCells = (
	categories: Category[],
): string[][] => {
	const cells: string[][] = [];
	for (const cat of categories) {
		for (const component of cat.components) {
			if (
				cat.weighting !== 0 &&
				component.select &&
				component.weighting !== 0
			) {
				cells.push([
					cat.name,
					cat.weighting.toString() + '%',
					component.name,
					cat.useHighestScore
						? '--'
						: component.weighting.toString() + '%',
				]);
			}
		}
	}
	return cells;
};
